export default __webpack_public_path__ + "static/media/Mood-Active.96a66911.png";